module.exports = __webpack_public_path__ + "assets/img/zbt_4.39a908e5.png";